import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOutAlt } from '@fortawesome/free-solid-svg-icons';
import {
  Dropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
} from 'reactstrap';
import {
  ACCOUNTANT_URL,
  DOCS_URL,
  POLICY_URL,
  USERS_URL,
  WORKFLOW_URL,
  ANALYST_URL,
  REASEGURO_URL,
  SINIESTROS_URL,
  ORSAN_LOGO_URL
} from 'CONST';
import { signout } from 'helpers/auth';
import isUserHasProfile from '../helpers/profileValidator';
import {
  GARANTIA_READ
} from '../helpers/profilePermission';
import NotificationBell from './shared/NotificationBell';
import 'styles/navbar.css';

class BaseNavbar extends Component {
  constructor(props) {
    super(props);

    this.toggleApps = this.toggleApps.bind(this);
    this.toggleGarantia = this.toggleGarantia.bind(this);
    this.handleSignOut = this.handleSignOut.bind(this);
    this.state = {
      appsOpen: false,
      clientsOpen: false,
    };
  }

  handleSignOut = event => {
    event.preventDefault();
    signout();
  };

  getSelectedClass = (path, exact = false) => {
    const currentPath = window.location.pathname;
    const homePath = "/garantia/clientes";

    // Maneja un arreglo the "paths"
    if (Array.isArray(path)) {
      if (path.some(p => exact ? currentPath === p : currentPath.startsWith(p)))
        return 'nav-selected';
    }

    if (typeof path === 'string') {
      if (exact ? currentPath === path : currentPath.startsWith(path))
        return 'nav-selected';
    }

    // Maneja el "home path"
    if (currentPath === "/" && (Array.isArray(path) ? path.includes(homePath) : homePath === path))
      return 'nav-selected';

    return '';
  };


  redirectWithToken = (event) => {
    event.preventDefault();
    const { token } = this.props;

    const url = event.target.href;

    const options = {
      method: 'GET',
      headers: {
        'X-JWT-TOKEN': token,
      },
      credentials: 'include',
    };

    fetch(url, options)
      .then((response) => {
        if (response.ok) {
          window.location.href = url;
        }
      })
      .catch(() => {});
  }

  toggleApps() {
    this.setState(state => ({
      appsOpen: !state.appsOpen,
    }));
  }

  toggleGarantia() {
    this.setState(state => ({
      clientsOpen: !state.clientsOpen,
    }));
  }

  render() {
    const { user } = this.props;
    const { clientsOpen, appsOpen } = this.state;
    return user && (
      <nav className="navbar-content">
        <div className="nav-logo-container">
          <Link to="/users">
            <img src={ORSAN_LOGO_URL} className="nav-logo" alt="" />
          </Link>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr auto' }}>
          <ul className="nav-links-group">
            <Dropdown
              nav
              className="nav-link-element"
              isOpen={appsOpen}
              toggle={this.toggleApps}
            >
              <DropdownToggle nav caret className="navbar-header">
                RIESGO
              </DropdownToggle>
              <DropdownMenu>
                {user.apps.includes('users') && (
                  <DropdownItem>
                    <a className="nav-link navbar-header" href={USERS_URL}>
                      USUARIOS
                    </a>
                  </DropdownItem>
                )}
                {user.apps.includes('docs') && (
                  <DropdownItem>
                    <a className="nav-link navbar-header" href={DOCS_URL}>
                      DOCUMENTOS
                    </a>
                  </DropdownItem>
                )}
                {user.apps.includes('policies') && (
                  <DropdownItem>
                    <a className="nav-link navbar-header" href={POLICY_URL}>
                      PÓLIZA
                    </a>
                  </DropdownItem>
                )}
                {user.apps.includes('accountant') && (
                  <DropdownItem>
                    <a className="nav-link navbar-header" href={ACCOUNTANT_URL}>
                      RESERVAS
                    </a>
                  </DropdownItem>
                )}
                {user.apps.includes('reaseguro') && (
                  <DropdownItem>
                    <a className="nav-link navbar-header" href={REASEGURO_URL}>
                      REASEGURO
                    </a>
                  </DropdownItem>
                )}
                {user.apps.includes('analista') && (
                  <DropdownItem>
                    <a className="nav-link navbar-header" href={ANALYST_URL}>
                      RIESGO DE CRÉDITO
                    </a>
                  </DropdownItem>
                )}
                {user.apps.includes('workflow') && (
                  <DropdownItem>
                    <a className="nav-link navbar-header" href={WORKFLOW_URL}>
                      SEGURO DE CRÉDITO
                    </a>
                  </DropdownItem>
                )}
                {user.is_orsan && (
                  <DropdownItem>
                    <a className="nav-link navbar-header" href={SINIESTROS_URL} onClick={this.redirectWithToken}>
                      SINIESTROS
                    </a>
                  </DropdownItem>
                )}
              </DropdownMenu>
            </Dropdown>
            {isUserHasProfile(GARANTIA_READ) && (
              <Dropdown
                nav
                className="nav-link-element"
                isOpen={clientsOpen}
                toggle={this.toggleGarantia}
              >
                <DropdownToggle nav caret className={`nav-pill ${this.getSelectedClass('/')}`}>
                  Garantía
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem>
                    <Link className={`nav-link ${this.getSelectedClass('/garantia/clientes')}`} to="/">
                      Lista de Clientes
                    </Link>
                  </DropdownItem>
                  <DropdownItem>
                    <Link className={`nav-link ${this.getSelectedClass('/garantia/oportunidades')}`} to="/garantia/oportunidades">
                      Oportunidades
                    </Link>
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            )}
          </ul>
          <ul className="nav-links-group">
            <li className="nav-link-element nav-ite">
              <NotificationBell />
            </li>
            <li className="nav-link-element nav-ite dropdown">
              <p className="nav-link">{user.username || ''}</p>
            </li>
            <li className="nav-link-element nav-item dropdown">
              <button type="button" className="btn btn-outline-orsan-logout mr-3" onClick={this.handleSignOut}>
                Cerrar Sesión
                <FontAwesomeIcon icon={faSignOutAlt} size="1x" className="ml-2" />
              </button>
            </li>
          </ul>
        </div>
      </nav>
    );
  }
}

BaseNavbar.propTypes = {
  user: PropTypes.shape({
    email: PropTypes.string,
    username: PropTypes.string,
    full_name: PropTypes.string,
    has_access: PropTypes.bool,
    apps: PropTypes.arrayOf(PropTypes.string),
    organization: PropTypes.number,
    sub: PropTypes.string,
    is_orsan: PropTypes.bool,
  }).isRequired,
  token: PropTypes.string,
};

BaseNavbar.defaultProps = {
  token: undefined,
};

const mapStateToProps = state => ({
  user: state.login.user,
  token: state.login.id_token,
});

export default withRouter(connect(mapStateToProps)(BaseNavbar));
